import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { authenticationService } from "../../../services/auth.service";

import "./transaction-history.css";

import api from "../../../services/api";
import toastOptions from "../../../utils/toastOptions";
import { useNavigate, useParams } from "react-router-dom";
import IPersonBilling from "../../../models/IPersonBilling";
import { currencyMask, displayDateTime } from "../../../utils/masks";
import DataTable from "react-data-table-component";

type RouteParams = {
  token: string;
}

export default function CampaignTransactionHistory() {
  const params = useParams<RouteParams>();
  const navigate = useNavigate();
  const [issues, setIssues] = useState<[]>([]);
  const [person, setPerson] = useState<any>();
  const opt = toastOptions;

  const columns = [
    {
      name: "Parcela",
      sortable: false,
      cell: (row: IPersonBilling) => <div className="uk-flex uk-flex-column">
        <span className="uk-text-bold">Parcela {row.numOfPayment ?? 0}</span>
        <span className="uk-text-muted">({row.month}/{row.year})</span>
      </div>
    },
    {
      name: "Pagamento",
      sortable: false,
      cell: (row: IPersonBilling) => <div className="uk-flex uk-flex-middle">
        <div className="uk-flex uk-flex-column">        
          <span>
            {currencyMask(row.paidAmount)}
          </span>
          <div className="uk-flex uk-flex-column">
            <span className="uk-text-italic">{displayDateTime(row.paidAt)}</span>
            <span className="uk-text-muted">{row.paymentType}</span>
          </div>
        </div>
      </div>
    }
  ];

  useEffect(() => {
    const init = async () => {
      setPerson(undefined);
      authenticationService.removeUserLogged();

      opt.onClose = () => {
        navigate("/");
      };

      if (!params.token) {
        toast.error("Você não foi permitido para acessar essa função", opt);
        return;
      }

      setIssues([]);

      try {
        
        const response = await api.get(`campaigns/transaction-history/${params.token}`);
  
        if (response.data.item == 'ISSUE') {
          return;
        }
        
        setPerson(response.data.item);
      } catch (e: any) {      
        setIssues(e?.messages);
      }
    };

    init();
  }, []);

  const renderInfo = () => {
    return <p>
      Caso não esteja vendo algum pagamento ou tenha alguma dúvida nos contate via WhatsApp
      <br />
      <a href="https://wa.me/5534992782927" target="_blank">
        <span>Dr. Guilherme</span>
      </a>/
      <a href="https://wa.me/5534992625950" target="_blank">
        <span>Pr. Frederico</span>
      </a>
    </p>
  }

  return (
    <div id="container" className="uk-container uk-margin-remove-bottom uk-padding">
      <div
        id="container-transaction"
        className="uk-flex uk-flex-center uk-flex-column uk-margin-top uk-width-1@m"
      >
        <div className="uk-card uk-card-default">
          <div className="uk-card-body">
            {(!person && issues?.length == 0) && (
              <div className="uk-flex uk-flex-center">
                <div uk-spinner="true; ratio:2">Carregando...</div>
              </div>
            )}
            {person && <div className="uk-margin-top uk-flex uk-flex-column" uk-grid="true">
              <h2 className="uk-text-lighter">Paz do Senhor, <span className="uk-text-bold">{person.name}</span>!</h2>
              {renderInfo()}
              <div className="uk-width-1@m">
                <h3 className="uk-text-lighter">Pagamentos</h3>
                <progress id="js-progressbar"
                  className="uk-progress" 
                  value={person.noOfPaymentsPaid} 
                  max={60}
                  uk-tooltip={`${person.noOfPaymentsPaid}/60`}
                ></progress>
                <DataTable
                  columns={columns}
                  data={person.billings}                  
                />          
              </div>
            </div>}
            {issues.length > 0 && <>              
              {renderInfo()}
              <h3 className="uk-text-lighter">Econtramos um problema!</h3>
              {issues.map(i => <h3 className="uk-text-danger uk-text-center uk-text-lighter">{i}</h3>)}
            </>}
          </div>
          <div className="uk-card-footer">
            Acesse nosso site: &nbsp;
            <a href="https://adbelemuberaba.com.br">
              <span>adbelemuberaba.com.br</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
